import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SourceRegular from './source-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SourceRegular {...validProps} />;
}
SvgComponent.iconName = 'sourceRegular';

export const SourceRegularIcon = svgIconWrapper(SvgComponent);
